import React from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  ActivityIndicator,
  KeyboardAvoidingView,
} from "react-native";

import { Formik } from "formik";
import { AuthContext } from "../../contexts/auth/Store";

import { AnalyticsService } from "../../constants/Analytics";
import Colors from "../../constants/Colors";
import FormikInput from "../../components/form/FormikInput";
import StyledButton from "../../components/StyledButton";
import http from "../../utils/http";

const analytics = new AnalyticsService();

export function PasswordScreen() {
  const authenticator = React.useContext(AuthContext);
  const [buyer, setBuyer] = React.useState<any>(null);

  React.useEffect(() => {
    setBuyer(authenticator.getUserData.buyerData);

    return () => {
      // cleanup
    };
  }, []);

  return (
    <KeyboardAvoidingView
      keyboardVerticalOffset={0}
      enabled={true}
      behavior={"position"}
    >
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={{ justifyContent: "flex-end" }}
      >
        {buyer ? (
          <Formik
            initialValues={{
              oldPassword: "",
              newPassword: "",
            }}
            onSubmit={(values, actions) => {
              actions.setSubmitting(true);
              let form = new FormData();

              form.append("username", buyer?.phone);
              form.append("hash_new", values.newPassword);
              form.append("hash_old", values.oldPassword);
              http
                .post(
                  "user/change_auth",
                  form,
                  authenticator.getUserData.userToken
                )
                .then((res) => {
                  actions.setSubmitting(false);
                  if (res.code == 200 && res.message) {
                    actions.resetForm();
                    // ToastAndroid.show('Password update successful', ToastAndroid.LONG, ToastAndroid.BOTTOM)

                    analytics.logEvent("Changed Password", buyer);
                  } else {
                    console.log(res);
                    // ToastAndroid.show('Password change failed', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                  }
                });
            }}
          >
            {({ handleSubmit, values, errors, isSubmitting }) => (
              <View>
                {/* form goes here */}
                <FormikInput
                  label="Old Password"
                  icon={{ name: "md-lock" }}
                  fieldName="oldPassword"
                  placeholder="Old password"
                  secureTextEntry={true}
                />
                <FormikInput
                  label="New Password"
                  icon={{ name: "md-lock" }}
                  fieldName="newPassword"
                  placeholder="New password"
                  secureTextEntry={true}
                />

                <StyledButton
                  label="Update"
                  submitting={isSubmitting}
                  disabled={
                    isSubmitting ||
                    values.oldPassword === values.newPassword ||
                    !!errors.newPassword
                  }
                  action={handleSubmit}
                  style={{
                    marginTop: 32,
                    marginBottom: 63,
                  }}
                />
              </View>
            )}
          </Formik>
        ) : (
          <View style={{ paddingTop: 42 }}>
            <ActivityIndicator size={48} color="#3B54EC" />
          </View>
        )}
      </ScrollView>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
  },
  scrollView: {
    flexGrow: 1,
    height: "100%",
    backgroundColor: Colors.whiteColor,
    paddingHorizontal: 16,
    paddingBottom: 25,
  },
});
